export default __webpack_public_path__ + "static/media/IMG_20211121_114134.422966cd.jpg";